import { useCallback } from 'react';

import { useAuth, useSession, useUser } from '@clerk/clerk-react';

// Viewer (認証済みユーザー) の状態を表す型
export interface Viewer {
  isLoaded: boolean;
  isSignedIn: boolean | undefined;
  user: ReturnType<typeof useUser>['user'];
  session: ReturnType<typeof useSession>['session'];
  getToken: () => Promise<string | null>;
}

/**
 * アプリケーションにおける認証されたユーザー(Viewer)の状態と情報を提供するフック
 */
export function useViewer(): Viewer {
  const { isLoaded: isAuthLoaded, isSignedIn } = useAuth();
  const { user } = useUser();
  const { session } = useSession();

  const getToken = useCallback(async (): Promise<string | null> => {
    if (!session) {
      console.error('useViewer: Session not available to get token.');
      return null;
    }
    try {
      return await session.getToken();
    } catch (error) {
      console.error('useViewer: Failed to get auth token:', error);
      return null;
    }
  }, [session]);

  return {
    isLoaded: isAuthLoaded,
    isSignedIn: isSignedIn,
    user,
    session,
    getToken,
  };
}

// 必要に応じて、ユーザープロファイル関連の型や API もここに含める
// (現状の get_profile, update_profile は未使用のため省略)
